module.exports = __webpack_public_path__ + "img/antes_despues_87.7b002f61.png";